export enum OrigemProtocoloEnum {
  SEI = 'SEI',
  INTERNO = 'INTERNO'
}
